import { Inline } from '@/ui/layout/Inline';
import { Box } from '@/ui/primitives/Box';
import type { SpacingToken } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives/types';
import type { ReactElement, ReactNode } from 'react';

type DialogFooterActionsProps = {
  children: ReactNode;
  startSlot?: ReactNode;
  gap?: SpacingToken;
  justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between';
  sx?: SxProps<Theme>;
};

export const DialogFooterActions = ({
  children,
  startSlot,
  gap = 'md',
  justify = 'flex-end',
  sx,
}: DialogFooterActionsProps): ReactElement => {
  if (startSlot) {
    return (
      <Inline gap={gap} justify={justify} wrap="wrap" sx={sx}>
        <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>{startSlot}</Box>
        <Inline
          gap={gap}
          justify="flex-end"
          wrap="wrap"
          sx={{ flex: '0 1 auto', minWidth: 0, width: 'auto' }}
        >
          {children}
        </Inline>
      </Inline>
    );
  }

  return (
    <Inline gap={gap} justify={justify} wrap="wrap" sx={sx}>
      {children}
    </Inline>
  );
};
